import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchRoleUsers } from '../services/roles';
import { roleKeys } from './useRolesQuery';
import type { RoleUsersParams, RoleUsersResponse } from '../types/roles.types';

export const useRoleUsersQuery = (id: string, params: RoleUsersParams) =>
  useQuery<RoleUsersResponse>({
    queryKey: roleKeys.users(id, params),
    queryFn: () => fetchRoleUsers(id, params),
    enabled: !!id,
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
